<script>
export default {
  name: 'VideoPlayer',
  props: {
    videoPath: {
      type: String,
      default: ''
    },
    videoCover: {
      type: String,
      default: ''
    },
    autoplay: {
      type: Boolean,
      default: true
    },
    pagePlay: {
      type: Boolean,
      default: true
    },
    pointerNone: {
      type: Boolean,
      default: false
    },
    controls: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    pagePlay(newVal) {
      if (!newVal) {
        this.$nextTick(() => {
          this.$refs['videoRef'].pause()
        })
      }
    }
  }
}
</script>

<template>
  <div class="video-container">
    <video
      ref="videoRef"
      :src="videoPath | filePath"
      :poster="videoCover | imgPath"
      :controls="controls"
      controlslist="nodownload"
      :autoplay="autoplay"
      :class="{'pointer-none': pointerNone}"
    />
  </div>
</template>

<style lang="scss" scoped>
.video-container {
  width: 100%;
  height: 100%;
}
video {
  width: 100%;
  height: 100%;
  border-radius: 5px;
  object-fit: cover;
}
.pointer-none {
  pointer-events: none;
}
</style>
